export const JSON_ONE1 = [
   
    {

        "me_id": "201711280012",
        "merchant_name": "Puma120"
    
    }
]

